import { render, staticRenderFns } from "./BillingBreakdown.vue?vue&type=template&id=a8935b7e&scoped=true"
import script from "./BillingBreakdown.vue?vue&type=script&lang=ts"
export * from "./BillingBreakdown.vue?vue&type=script&lang=ts"
import style0 from "./BillingBreakdown.vue?vue&type=style&index=0&id=a8935b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8935b7e",
  null
  
)

export default component.exports